"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultStorageUrls = getDefaultStorageUrls;
var _zodUtils = require("@ori/zod-utils");
var _getStorageUrls = require("./getStorageUrls");
function getDefaultStorageUrls() {
  const environment = (0, _zodUtils.validateEnvironment)(process.env.ENVIRONMENT) ?? '';
  const region = process.env.REGION ?? process.env.Region ?? '';
  return (0, _getStorageUrls.getStorageUrls)(environment, region);
}
//# sourceMappingURL=getDefaultStorageUrls.js.map